<template>
  <div>
    <div class="switch-field" v-if="theme == 1">
      <label
        v-for="(item, index) in list"
        :class="selectedClass(index)"
        :key="index"
        for="all"
        @click="emit(item, index)"
        >{{ getValue(item) }}</label
      >
    </div>
    <div v-if="theme === 2" style="display: inline-flex">
      <div style="width: 91.25px; display: inline-table">
        <div
          class="theme-2-item"
          @click="emit(0, -1)"
          :class="selectedClass(-1)"
        >
          <a>
            <img class="img-fluid" src="@/assets/img/room-1.jpg" alt />
            <h6>All</h6>
            <!-- <p>120</p> -->
          </a>
        </div>
      </div>
      <div style="width: 91.25px">
        <div
          class="theme-2-item"
          @click="emit(-1, -2)"
          :class="selectedClass(-2)"
        >
          <a>
            <img class="img-fluid" src="@/assets/img/room-1.jpg" alt />
            <h6>Produts</h6>
            <!-- <p>120</p> -->
          </a>
        </div>
      </div>

      <div style="width: 91.25px" v-for="(item, index) in list" :key="index">
        <div
          class="theme-2-item"
          @click="emit(item, index)"
          :class="selectedClass(index)"
        >
          <a>
            <img
              v-if="imageExists(item.image)"
              class="img-fluid"
              :src="item.image"
              alt
            />
            <img
              v-else
              class="img-fluid"
              src="@/assets/img/image-not-found.png"
              alt
            />
            <h6>{{ getValue(item) }}</h6>
            <!-- <p>120</p> -->
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListingFilter',
  props: {
    value: {
      type: String,
      default: null,
    },
    visibleAll: {
      type: Boolean,
      default: true,
    },
    list: {
      type: Array,
      default: [],
    },
    itemText: {
      type: String,
      default: null,
    },
    theme: {
      type: Number,
      default: 1,
    },
  },
  data: () => ({
    selectedIndex: null,
  }),
  methods: {
    emit(value, index) {
      this.selectedIndex = index;
      this.$emit('input', value);
    },
    getValue(item) {
      if (this.itemText) {
        return item[this.itemText];
      }
      return item.id;
    },
    selectedClass: function (index) {
      var className = null;
      if (this.selectedIndex == index) {
        switch (this.theme) {
          case 1:
            className = 'theme-1-selected';
            break;
          case 2:
            className = 'theme-2-selected';
            break;
          default:
            className = 'theme-1-selected';
        }
        return className;
      }
      return '';
    },
    imageExists(image_url) {
      if (image_url) {
        var http = new XMLHttpRequest();

        http.open('HEAD', image_url, false);
        http.send();

        return http.status != 404;
      }
    },
  },
};
</script>

<style scoped>
.theme-1-selected {
  color: white;
  background: var(--brand-primary, #512d82);
}
.theme-1-selected:hover {
  color: white;
  background: var(--brand-primary-hover, #3f2366);
}
.theme-2-selected {
  border: 1px solid var(--brand-primary, #512d82) !important;
}
.theme-2-selected:hover {
  border: 1px solid var(--brand-primary-hover, #3f2366);
}

.theme-2-item {
  background: #fff;
  margin: 5px 2px;
  border-radius: 3px;
  overflow: hidden;
  text-align: center;
  padding: 7px;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
  border: 1px solid #fff;
}
.theme-2-item:hover {
  border: 1px solid var(--brand-primary, #512d82);
}
.theme-2-item h6 {
  margin: 0px;
  font-size: 13px;
  color: var(--brand-primary, #512d82);
}
.theme-2-item p {
  margin: 0px;
  font-size: 12px;
}
.theme-2-item img {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 50px;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
  margin: 2px 0 8px 0;
}
</style>
